import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import MobileBar from "./components/MobileBar";

// Pages
import Home from "./pages/Home";
import Leistungen from "./pages/Leistungen";
import HaushaltsaufloesungDortmund from "./pages/HaushaltsaufloesungDortmund";
import WohnungsaufloesungDortmund from "./pages/WohnungsaufloesungDortmund";
import MessieWohnungDortmund from "./pages/MessieWohnungDortmund";
import KellerDachbodenDortmund from "./pages/KellerDachbodenDortmund";
import SperrmuellDortmund from "./pages/SperrmuellDortmund";
import NachlassaufloesungDortmund from "./pages/NachlassaufloesungDortmund";
import Preise from "./pages/Preise";
import Einsatzgebiet from "./pages/Einsatzgebiet";
import UeberUns from "./pages/UeberUns";
import Kontakt from "./pages/Kontakt";
import FAQ from "./pages/FAQ";
import Blog from "./pages/Blog";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import Sitemap from "./pages/Sitemap";
import Danke from "./pages/Danke";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Header />
          <main className="min-h-screen">
            <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/leistungen" element={<Leistungen />} />
            <Route path="/haushaltsaufloesung-dortmund" element={<HaushaltsaufloesungDortmund />} />
            <Route path="/wohnungsaufloesung-dortmund" element={<WohnungsaufloesungDortmund />} />
            <Route path="/messie-wohnung-dortmund" element={<MessieWohnungDortmund />} />
            <Route path="/keller-dachboden-entruempelung-dortmund" element={<KellerDachbodenDortmund />} />
            <Route path="/sperrmuell-abtransport-dortmund" element={<SperrmuellDortmund />} />
            <Route path="/nachlassaufloesung-dortmund" element={<NachlassaufloesungDortmund />} />
            <Route path="/preise" element={<Preise />} />
            <Route path="/einsatzgebiet-dortmund" element={<Einsatzgebiet />} />
            <Route path="/ueber-uns" element={<UeberUns />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/sitemap" element={<Sitemap />} />
            <Route path="/danke" element={<Danke />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <MobileBar />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
